import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { Toll } from '../../shared/models/components-general/menu-toll.model';
import { PageGeneralComponent } from '../../general-page/build-page-dynamic/page-general/page-general.component';
import { MatIcon } from '@angular/material/icon';
import { QuotationService } from '../../shared/services/quotation.service';
import { MatTableDataSource } from '@angular/material/table';
import { QuotationModel } from '../../shared/models/quotation-model/quotation.model';
import { InputGeneral } from '../../shared/inputs/input-general/input-general';
import { FormControl } from '@angular/forms';
import { GeneralService } from '../../shared/services/general.service';
import { ModalCommentInterface } from '../../shared/models/components-general/modal-genearal.model';
import { ModalGeneralCommentComponent } from '../../shared/modals/modal-general-comment/modal-general-comment.component';
import { MatDialog } from '@angular/material/dialog';
import { MigrationUtilityService } from '../../shared/services/migration-utility.service';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-quotation-page-general',
  templateUrl: './quotation-page-general.component.html',
  styleUrls: ['./quotation-page-general.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    PageGeneralComponent,
    MatIcon,
    InputGeneral,
    MatButtonModule,
    MatTooltip,
  ],
})
export class QuotationPageGeneralComponent {
  public isExpanded: boolean = false;
  public searchControl = new FormControl('');
  public dataSource = new MatTableDataSource<QuotationModel>([]);
  public quotationId: number | null = 0;
  public tollArray: Toll[] = [
    // {
    //   icon: 'arrow_back',
    //   tolltip: 'Anterior Formulario',
    //   type: 'scroll',
    //   function: 'scrollLeft',
    // },
    {
      icon: 'arrow_forward',
      tolltip: 'Siguiente Formulario',
      type: 'scroll',
      function: 'scrollRight',
    },
    {
      icon: 'check',
      tolltip: 'Guardar Formulario',
      type: 'green',
      function: 'saveFrom',
    },
  ];

  constructor(
    private quotationService: QuotationService,
    private generalService: GeneralService,
    public dialog: MatDialog,
    private migrationUtilityService: MigrationUtilityService,
  ) {
    this.getQuotationProgress(Number(localStorage.getItem('userId')));
    this.generalService.subscribeFormSimple(this.searchControl).subscribe((value) => {
      this.dataSource.filter = value?.trim().toLowerCase() || '';
    });
  }

  private getQuotationProgress(userId: number) {
    this.quotationService.getQuotationProgress(userId).subscribe((data) => {
      if (data) {
        this.dataSource.data = data || [];
      }
    });
  }

  public setQuotationId(quotationId: number): void {
    this.quotationId = null;
    setTimeout(() => {
      this.isExpanded = false;
      this.quotationId = quotationId;
    }, 200);
  }

  public openModalCancelQuotation(quotationId: number): void {
    const dataAux: ModalCommentInterface = {
      Titule: 'Cancelar Cotización',
      buttonClose: true,
      isRequired: true,
      button: 'Cancelar',
      placeholder: 'Comentario',
      text: 'Estas por cancelar esta cotización: ' + quotationId,
    };
    const dialogRef = this.dialog.open(ModalGeneralCommentComponent, {
      width: '500px',
      height: '450px',
      disableClose: true,
      autoFocus: false,
      data: dataAux,
    });
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        const userId = localStorage.getItem('userId');
        this.migrationUtilityService
          .changeQuotationStatus({
            quotationId: quotationId ?? 0,
            userId: Number(userId),
            newStatus: 'CANCELADO',
            comment: result,
          })
          .subscribe((ress) => {
            this.generalService.viewSnacAlert(
              `Solicitud ${quotationId ?? 0} cancelada`,
              'normal',
              'Cancelada',
            );
            window.location.reload();
          });
      }
    });
  }
}
